module.exports = __webpack_public_path__ + "img/error-url.5b255b2a.svg";